export class RemortgageUtils {
  // Returns the borrower names to display for a matter.
  //
  // Prefer the per-matter names Knights sent on this matter (BorrowerDetails.Borrower{1..4}
  // Forname/Surname). The Borrowers[] login rows are shared between every matter a borrower
  // has under the same email, and they keep the name from whichever matter created the login,
  // so they can show another matter's name here (SUPPORT-5885). They also collapse two
  // borrowers who share an email into a single login. Fall back to the login rows only when
  // the matter carries no borrower names at all.
  static getBorrowers(borrowers, borrowerDetails) {
    const matterNames = this.getMatterBorrowerNames(borrowerDetails);
    if (matterNames.length > 0) {
      return matterNames.join(", ");
    }
    return this.getLoginBorrowerNames(borrowers).join(", ");
  }

  static getMatterBorrowerNames(borrowerDetails) {
    if (!borrowerDetails) return [];
    const names = [];
    for (let i = 1; i <= 4; i++) {
      const forname = borrowerDetails[`Borrower${i}Forname`];
      const surname = borrowerDetails[`Borrower${i}Surname`];
      const name = this.joinName(forname, surname);
      if (name) names.push(name);
    }
    return names;
  }

  static getLoginBorrowerNames(borrowers) {
    if (!Array.isArray(borrowers)) return [];
    return borrowers
      .filter((borrower) => this.hasBorrowerInfo(borrower))
      .map((borrower) => this.joinName(borrower.firstname, borrower.lastname));
  }

  static joinName(forname, surname) {
    return [forname, surname]
      .filter((part) => typeof part === "string" && part.trim() !== "")
      .map((part) => part.trim())
      .join(" ");
  }

  static hasBorrowerInfo(borrower) {
    return (
      !!borrower &&
      borrower.firstname !== null &&
      borrower.firstname !== "" &&
      borrower.lastname !== null &&
      borrower.lastname !== ""
    );
  }
}
